import React,{Component} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMapMarkedAlt} from '@fortawesome/free-solid-svg-icons';
import NumberBox from './NumberBox'

 class TrackIcon extends Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.state = {
            showTrackingBox: true,
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps, prevState) {



    }
    handleClickOutside(event) {
        if (this.state.showTrackingBox == true &&
            this.wrapperRef &&
            !this.wrapperRef.current.contains(event.target)
            && this.props.canHide==true
        ) {
            this.toggleTrackingBox();
            event.stopPropagation();
        }
    }



    toggleTrackingBox() {
        this.setState({showTrackingBox: !this.state.showTrackingBox})
    }



    render() {



        return (
            <div ref={this.wrapperRef}>
                {(this.state.showTrackingBox ) && (
                    <div className={"floatingTrackingBoxCard"}>
                        <NumberBox
                            loading={this.props.loading}
                            onTrack={() => {
                            this.toggleTrackingBox()
                            this.props.onTrack()
                        }}
                                   onRemove={(index) => this.props.onRemove(index)}
                                   onRemoveAll={(index) => this.props.onRemoveAll(index)}


                        />
                    </div>
                )}

                <div className="track-button-container">
                    <button
                        onClick={() => this.toggleTrackingBox()}
                        aria-describedby={"trackbuttonsmall"}
                        type="submit"
                        className="btn btn-primary pillbutton menu-button "
                        style={{borderRadius: '50%', width: '50px', height: '50px'}}>
                        <FontAwesomeIcon style={{marginRight: '3px', marginLeft: '3px', color: '#ffffff'}}
                                         icon={faMapMarkedAlt}/>
                    </button>
                </div>
            </div>
        );
    }
}

//TrackItem.propTypes = propTypes;
export default (TrackIcon);
